<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="loadResults"
    />
    <div
      v-if="!invalid"
      class="text-wrapper"
    >
      <h2 class="subtitle is-size-3-mobile is-marginless">
        {{ name }},
      </h2>
      <h2 class="subtitle is-size-3-mobile is-marginless">
        based on your answers,
      </h2>
      <h2 class="subtitle is-size-3-mobile is-marginless">
        <b>these are your shades of blue!</b>
      </h2>
    </div>
    <div
      v-else
      class="text-wrapper"
    >
      <h2 class="subtitle is-size-3-mobile is-marginless">
        <b>It's still too tricky to find your shade of blue,</b>
      </h2>
      <h2
        class="subtitle is-size-3-mobile is-marginless"
      >
        Please try this quiz again and vary your answers.
      </h2>
    </div>
    <div
      v-if="suggestions.length > 0"
      class="columns is-desktop result-wrapper"
      :class="noPadding"
    >
      <div
        v-for="suggestion in suggestions"
        :key="suggestion"
        class="column"
      >
        <div
          class="result-box"
          :class="selectedClass(suggestion)"
          @click="setSelected(suggestion)"
        >
          <h2 class="subtitle is-size-3-mobile has-text-centered">
            <b>{{ suggestion }}</b>
          </h2>
          <p class="sub-more">
            <b class="more-text">read more</b>
            <img
              src="../assets/arrow.png"
              class="more-button"
              alt="next"
            >
          </p>
        </div>
        <result-strip
          v-if="selected === suggestion"
          :result="selected"
        />
      </div>
    </div>
    <p
      v-if="bintang && !selected && !invalid"
      class="is-style-accent is-size-3-desktop is-size-4-mobile"
    >
      * However, if you are a
      <b>&nbsp;non-Management student</b>, the division that is available for your to apply is
      <b>&nbsp;Delegate Relations&nbsp;</b>division.
    </p>
  </div>
</template>

<script>
import ResultStrip from "./ResultStrip.vue";
import data from "../results.json";

export default {
  name: "Result",
  components: {
    ResultStrip,
  },
  props: { quizData: Object },
  data() {
    return {
      loadResults: true,
      suggestions: [],
      selected: null,
      invalid: false,
      bintang: false
    };
  },
  computed: {
    name() {
      return this.quizData.user.name;
    },
    noPadding() {
      return !this.selected ? "is-paddingless" : null;
    }
  },
  async mounted() {
    this.bintang = this.quizData.user.major !== "Management";
    const total = Object.keys(this.quizData.answers).reduce(
      (accum, key) => (accum += this.quizData.answers[key]),
      0
    );
    if (total == 0 || total == Object.keys(this.quizData.answers).length * 5) {
      this.invalid = true;
      this.loadResults = false;
      return;
    }
    try {
      
      // Get users quiz answers
      const answers = [];
      for(var i in this.quizData.answers)
          answers.push([i, this.quizData.answers[i]]);
      
      // Sort answers highest - lowest based on answer score
      const sortedAnswers = answers.sort((a, b) => {
        if (b[1] === a[1]) {
          Math.random() < 0.5 ? 1 : -1;
        } else {
          return b[1] - a[1];
        }    
      });
      console.log(sortedAnswers)


      // Get all possible results from
      const allResults = data.suggestions

      // Get final results based on answers
      const finalResults = []
      finalResults.push(allResults[sortedAnswers[0][0]])
      finalResults.push(allResults[sortedAnswers[1][0]])
      finalResults.push(allResults[sortedAnswers[2][0]])
      console.log("FinalResults")
      console.log(finalResults)
      this.suggestions = finalResults
      this.loadResults = false;
      
    } catch (error) {
      this.loadResults = false;
      console.error(error);
    }
  },
  methods: {
    setSelected(suggestion) {
      this.selected = suggestion;
      setTimeout(() => window.scroll(0, 400), 300);
    },
    selectedClass(key) {
      return this.selected === key ? "selected" : null;
    }
  }
};
</script>

<style scoped>
.columns {
  padding-bottom: 61vh;
}

.stretch{
  margin: 0 !important;
  padding: 0 !important;
}
.column {
  padding: 15px;
}

.result-wrapper {
  margin-top: 15px;
}

.result-box {
  background: white;
  min-height: 300px;
  border-radius: 15px;
  padding: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s all;
  cursor: pointer;
  position: relative;
}

.result-box .subtitle {
  color: #000942 !important;
  text-transform: capitalize;
  transition: 0.2s all;
}

.result-box:hover {
  background: linear-gradient(to right, #141c53, #000942);
}

.result-box:hover .subtitle {
  color: #fff !important;
}

.result-box.selected {
  background: linear-gradient(to right, #141c53, #000942);
}

.result-box.selected .subtitle {
  margin: 0;
  color: #fff !important;
}

.sub-more {
  position: absolute;
  display: flex;
  bottom: 30px;
  align-items: center;
}

.more-button {
  max-height: 40px;
  transition: 0.2s all;
}

.more-text {
  padding-right: 10px;
  font-size: 24px;
  color: #000942 !important;
  transition: 0.2s all;
}

.result-box:hover .more-text {
  color: #fff !important;
}

.result-box:hover .more-button {
  filter: invert(1);
}

.result-box.selected .more-text {
  display: none;
}

.result-box.selected .more-button {
  display: none;
}

@media screen and (max-width: 991px) {
  .columns {
    padding-bottom: unset;
  }

  .result-box {
    min-height: 150px;
  }

  .sub-more {
    bottom: 15px;
  }

  .more-button {
    max-height: 15px;
  }

  .more-text {
    font-size: 16px;
  }
}
</style>
